// eslint-disable-next-line no-unused-vars
import React from 'react'; 
import { withStyles } from '@material-ui/core/styles';

import { connect } from "react-redux";

import { withTranslation } from 'react-i18next';
import i18n from "i18next";

import { getBannerImageUrlLabel, getBannerRedirectUrl } from "../utils/EventBanner";

const styles = () => ({
	root: {
		maxWidth: 1075,
		margin: ".45em auto",
	},
	content: {
	    textAlign: "center",
	},
	tick_sign: {
		textAlign: "center",
	},
	thank_you_title: {
	    fontSize: "2em",
	    height: "auto",
		fontFamily: "AIGFutura_Bold",
		paddingBottom: ".2em",
	},
	thank_you_heading: {
	    fontSize: "1.5em",
	    paddingBottom: "1em",
		fontFamily: "AIGFutura_Book",
		color: "rgb(155, 155, 155)",
	},
	rowFixMargin: {
		margin: 0,
	},
	tickEl: {
		fontSize: "5em",
		color: "rgb(38, 172, 232)",
	},
	bannerContainer: {
		padding: "1.5em 0",
	},
	bannerImage: {
		width: "100%",
	}
});

function CompletedPage(props) {
	const { classes, t, eventCode } = props;

	const langCode = i18n.language;
	const travel_10_off_banner_url_en = window.travel_10_off_banner_url_en;
	const travel_10_off_banner_url_zh = window.travel_10_off_banner_url_zh;

	if (typeof dataLayer !== 'undefined' && $.isArray(dataLayer)) {
		dataLayer.push({
			'event': 'conversion_done',
			'albert_product_name': 'Travel_campaign_postpone_submission'
		});
	}


	return (
		<div className={classes.root}>
  			
  		    <div className={`row center-xs middle-sm ${classes.rowFixMargin}`}>
  		        <div className={`col-xs-11 col-sm-10 col-lg-9`}>
  		            <div className={classes.content}>

						<div className={classes.bannerContainer}>
							{getBannerRedirectUrl(eventCode, langCode) === "" ?
								<img className={classes.bannerImage} src={t(getBannerImageUrlLabel(eventCode))} />
								:
								<a href={t(getBannerRedirectUrl(eventCode, langCode))}>
									<img className={classes.bannerImage} src={langCode === 'zh' ? travel_10_off_banner_url_zh : travel_10_off_banner_url_en} />
								</a>
							}

						</div>

						<div className={classes.tick_sign}>
  		            		<i aria-hidden="true" className={`icon-motis-tick ${classes.tickEl}`} />
  		            	</div>
  		            
  		                <h1 className={classes.thank_you_title}>
  		                    {t("thank_you_page_title")}
  		                </h1>
  		                    
  		                <div className={classes.thank_you_heading}>
  		                	<div dangerouslySetInnerHTML={{__html: t('thank_you_description')}} />
	                    </div>
	                    
  		            </div>
  		            
  		        </div>
  		    </div>
  		    
  		</div>
  	);
}

const mapStateToProps = state => {
	const { eventCode } = state;

	return { eventCode };
};

export default connect(mapStateToProps, {})(
	withTranslation()(
		withStyles(styles)(CompletedPage)
	)
);